/* 🤖 this file was generated by svg-to-ts */
export const siriusTimerLightPictogram: {
  name: 'timer_light_pictogram';
  data: string;
} = {
  name: 'timer_light_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path d="M24 6.375A17.625 17.625 0 1 0 41.625 24 17.645 17.645 0 0 0 24 6.375Zm0 33A15.374 15.374 0 1 1 39.375 24 15.392 15.392 0 0 1 24 39.375Zm8.22-23.595a1.125 1.125 0 0 1 0 1.59l-7.424 7.425a1.125 1.125 0 0 1-1.591-1.59l7.424-7.425a1.125 1.125 0 0 1 1.591 0ZM18.375 1.5A1.125 1.125 0 0 1 19.5.375h9a1.125 1.125 0 1 1 0 2.25h-9A1.125 1.125 0 0 1 18.375 1.5Z" fill="currentColor"/></svg>`
};
